const data = [
    {
        id:'prisonbreak',
        title:'Prisonbreak',
        info:'Highschool is over, you did it! The journey just started though...',
        icon:"handcuffs.svg",
        score:'63/100',
        date:'2014'
    },
    {
        id:'initiation',
        title:'Initiation of the scholar',
        info:'Computer Engineering Bachelor Degree achieved with success! You can now pretend to know everything about the world. <a href="https://github.com/machine1104/tesiTriennale/blob/master/tesi.pdf" target="_blank">See thesis</a>',
        icon:"old_book.svg",
        score:'93/110',
        date:'2019',
        link: true,
        link_route: 'bachelor_thesis',
        link_text: 'See thesis here'
    },
    {
        id:'mastering',
        title:'Mastering the art',
        info:'This odyssey is over and your efforts have paid off. You obtained the Holy Scroll (Master\'s degree in Engineering in Computer Science) that will pave all the ways for you. Or at least that\'s what you hope for. <a href="https://github.com/machine1104/MasterThesis/blob/main/Tesi.pdf" target="_blank">See thesis</a>',
        icon:"crown.svg",
        score:'103/110',
        date:'2022'
    },
    {
        id:'stage',
        title:'Stage',
        info:'You took part in your first and only internship. In three months you learned more than during all the years of study about how to develop new features inside management dashboards using Spring Framework.',
        icon:"engineering.svg",
        date:'05/2022 - 07/2022'
    },
    {
        id:'job_one',
        title:'Junior Operation Rete di Distribuzione ',
        info:'Your first job at E-Distribuzione. Enjoy it, it could be the last.',
        icon:"edistribuzione.svg",
        date:'09/2022 - Present'
    },

]

export default data;